export default __webpack_public_path__ + "assets/svg/ResistanceBand.425d761314c107af89d9b9744b439da6.svg";